import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import React, { ReactNode, ComponentProps } from 'react';
interface BaseTooltipProps {
  children: ReactNode;
  content: ReactNode | string;
  sideOffset?: number;
  side?: 'top' | 'left' | 'right' | 'bottom';
  className?: string;
  classNames?: {
    trigger?: string;
    content?: string;
  };
  tooltipProps?: Omit<ComponentProps<typeof Tooltip>, 'children'>;
  contentProps?: Omit<ComponentProps<typeof TooltipContent>, 'children'>;
}

export const BaseTooltip = ({
  children,
  content,
  side = 'right',
  sideOffset,
  className,
  classNames,
  tooltipProps,
  contentProps,
}: BaseTooltipProps) => {
  if (!content) return <>{children}</>;
  return (
    <TooltipProvider>
      <Tooltip {...tooltipProps}>
        <TooltipTrigger asChild className={cn(className, classNames?.trigger)}>{children}</TooltipTrigger>
        <TooltipContent
          sideOffset={sideOffset}
          side={side}
          className={cn(classNames?.content, 'whitespace-normal break-words')}
          {...contentProps}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
